import React, { useEffect } from "react";
import { RootState } from "us.helper/types";
import * as Actions from "actions";
import { connect, ConnectedProps } from "react-redux";
import { TemplateContent, TemplateMenu } from "./Components";
import { Formik } from "formik";
import { useLocation, useNavigate } from "react-router-dom";
import { initSetUrlParams } from "./Functions";
import "./home.scss";
import { DocumentType } from "constants/TemplateEditor";
import { ItemType, TemplateStatus } from "./Constants";

/**
 * @description - Template editor home page.
 * @link Design Document -
 * @author Ishan Udyoga <ishanud@unicorn-solutions.com>
 * @since 11/09/2022
 */
const EditorHome: React.FC<PropsFromRedux> = (props) => {
  const { getTemplates, getDocumentTypes, templates } = props;

  const { search } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    getTemplates && getTemplates({});
    getDocumentTypes && getDocumentTypes({});
  }, []);

  useEffect(() => {
    if (templates.groups && !templates.loading) {
      if (!search) {
        initSetUrlParams(templates.groups, search, (url: string) => navigate(url, { replace: true }));
      }
    }
  }, [templates.groups, search]);

  return (
    <Formik
      initialValues={{
        searchText: "",
        activityNo: "",
        documentType: DocumentType.ALL,
        templateStatus: TemplateStatus.ALL,
        itemType: ItemType.TEMPLATE,
        displayName:"",
      }}
      enableReinitialize
      onSubmit={() => {}}
    >
      {() => (
        <div className="editor-home-layout">
          <TemplateMenu />
          <TemplateContent />
        </div>
      )}
    </Formik>
  );
};

const mapStateToProps = (state: RootState) => {
  const { templatesHistory } = state;
  const { templates } = templatesHistory;

  return {
    templates,
  };
};

const { templatesHistory } = Actions;
const { templates, documentTypes } = templatesHistory;

const mapDispatchToProps = {
  getTemplates: templates.get,
  getDocumentTypes: documentTypes.get,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(EditorHome);
